import { Injectable } from '@angular/core';
import { CommonService } from '../../service/common.service'
import { NoiseAnalysisLineParam } from './noise-analysis-line-interface';
import * as _ from 'lodash';


import * as backgroundColor from '../../config/backgroundColor';
import * as color from '../../config/colors';
import * as toolbox from '../../config/toolbox';
import * as tooltip from '../../config/tootip';
import * as legend from '../../config/legend';
import * as xAxis from '../../config/xAxis';
import * as yAxis from '../../config/yAxis';
import * as series from '../../config/series';
import * as grid from '../../config/grid';
import * as brush from '../../config/brush';

type axisLabelRotate = 'leftSmallAngle' | 'leftBigAngle' | 'rightSmallAngle' | 'rightBigAngle';


@Injectable({
  providedIn: 'root'
})
export class NoiseAnalysisLineService {

  constructor(
    private commonService: CommonService
  ) { }

  style = this.commonService.setNoiseAnalysisLineByWindows();

  //todo 获取默认option
  getDefaultOpitonsOfNoiseAnalysisLineChart = () => {
    let chartOpt = {
      backgroundColor: backgroundColor.backgroundColor,
      grid: grid.getNoiseAnalysisLineGrid(this.style),
      toolbox: {
        show: true,
        itemGap: this.style.toolbox.itemGap,
        showTitle: true,
        right: this.style.toolbox.right, // 右边距 
        top: 10, // 上边距
        itemSize: this.style.toolbox.itemSize, //工具栏 icon 的大小
      },
      tooltip: tooltip.getNoiseAnalysisLineTooltip(),
      xAxis: xAxis.getXaxisOfNoiseAnalysisLine(0, []),
      yAxis: yAxis.getYaxisOfNoiseAnalysisLine([]),
      series: series.getBasicLineChartSeriesWithoutData()
    }
    return chartOpt
  }



  //todo 更改toolbox显示状态
  changeToolboxShow(chartOpt, bcacChartShowToolbox: boolean) {
    chartOpt.toolbox.show = typeof (bcacChartShowToolbox) == "string"
      ? JSON.parse(bcacChartShowToolbox)
      : bcacChartShowToolbox;
  }

  //todo 更改toolbox显示项目
  changeToolboxItem(chartOpt, toolboxDatas, funcObj) {
    if (toolboxDatas.toolboxItem && toolboxDatas.toolboxItem.includes('brush')) {
      chartOpt.brush = brush.getNoiseAnalysisLineXBrush()
    }
    let toollist = toolboxDatas.toolboxItem ? toolboxDatas.toolboxItem:[]
    chartOpt.toolbox = toolbox.getNoiseAnalysisLineToolbox(this.style, toollist, funcObj);
  }

  //todo 更改x轴名称
  changeXAxisName(xAxis, xAxisName: string) {
    xAxis[0].name = xAxisName
    return xAxis
  }
  //todo 更改y轴名称
  changeYAxisName(yAxis, yAxisName: string) {
    yAxis[0].name = yAxisName;
    return yAxis
  }
  //todo 更改y轴名称距离
  changeYAxisNameGap(yAxis, yAxisNameGap: number) {
    yAxis[0].nameGap = yAxisNameGap;
    return yAxis
  }

  //todo 更改x轴刻度label旋转
  changeXAxisLabelRotate(chartOpt, xAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (xAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.xAxis[0].axisLabel.rotate = rotate;
  }
  //todo 更改y轴刻度label旋转
  changeYAxisLabelRotate(chartOpt, yAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (yAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.yAxis[0].axisLabel.rotate = rotate;
  }


  //todo 更改单位Format
  setTooltipFormat(option: any, value: string) {
    option.tooltip = tooltip.getNoiseAnalysisLineTooltip(value);
  }

  //todo 更改chartData
  changeChartData(chartOpt, data: NoiseAnalysisLineParam) {
    let colorMap = _.zipObject(data.rectTypeLists, color.defaultColors);
    let rectlegend = []
    for (const item in colorMap) {
      rectlegend.push({
        name: item,
        textStyle: {
          fontSize: 10,
          color: colorMap[item]  //text颜色
        }
      })
    }
    let monitorItem = []
    if (data.toolboxDatas && data.toolboxDatas.multipleChoiceData) {
      data.toolboxDatas.multipleChoiceData.map((item) => {
        monitorItem.push(item.value)
      })
    }
    chartOpt.legend = legend.getNoiseAnalysisLineLegend(this.style, monitorItem, rectlegend)
    let xInterval = data.xInterval ? data.xInterval : 0
    chartOpt.xAxis = data.xFormatter
      ? xAxis.getXaxisOfNoiseAnalysisLine(xInterval, data.xAxisDatas, data.xFormatter)
      : xAxis.getXaxisOfNoiseAnalysisLine(xInterval, data.xAxisDatas)
    chartOpt.series = series.geSeriesOfNoiseAnalysisLine(data, colorMap)
    let catery = new Array(data.rectTypeLists.length).fill('')
    chartOpt.yAxis = yAxis.getYaxisOfNoiseAnalysisLine(catery)
    return chartOpt
  }


}


